import Component from '../../js/component';

class Checkbox extends Component {
  constructor(props) {
    super();

    this.options = {
      parent: document,
    };

    Object.assign(this.options, props);

    this.init();
  }

  init() {
    this.events();
  }

  events() {
    $(this.options.parent).on('click.cd.checkbox', this.options.el, event => this.clickEvent(event));
  }

  clickEvent(event) {
    event.stopPropagation();
    let $this = $(event.currentTarget);

    if ($this.parent().hasClass('checked')) {
      $this.parent().removeClass('checked');
    } else {
      $this.parent().addClass('checked');
    }
    
    this.emit('change', event, $this.val());
  }
}

export default Checkbox;



//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/checkbox/checkbox.js
// module id = 548
// module chunks = 9